<template>
  <div>
    <div class="title">总体服务评分</div>
    <div class="start-box">
      <div v-for="index in 5" :key="index">
        <img
          alt="星星"
          src="../../../assets/teacher/red_star.png"
          v-if="stIndex >= index"
          @click="clickStar(index)"
        />
        <img
          alt="星星"
          src="../../../assets/teacher/ash_star.png"
          v-else
          @click="clickStar(index)"
        />
      </div>
    </div>
    <div class="content-tab">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="item"
        :class="item.flag ? 'ch' : ''"
        @click="clickTab(item)"
      >
        {{ item.title }}
        <img
          class="check-img"
          src="../../../assets/teacher/check.png"
          v-if="item.flag"
        />
      </div>
    </div>
    <div class="textarea">
      <textarea
        name=""
        style="resize:none"
        id=""
        placeholder="请输入您对本次咨询的评价"
        v-model="eve"
      ></textarea>
    </div>
    <div class="btn" @click="submit">发布</div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {},
  data() {
    return {
      list: [],
      stIndex: -1,
      checkItemId: -1,
      id: "",
      eve: "",
    };
  },
  mounted() {},
  created() {
    this.id = this.$route.query.id;
    this.getDataList();
  },
  methods: {
    getDataList() {
      this.api.commentTag().then((res) => {
        this.list = res.data;
        this.list.map((r) => {
          r.flag = false;
        });
      });
    },
    clickStar(index) {
      this.stIndex = index;
    },
    clickTab(item) {
      // this.checkItemId = item.id;
      item.flag = !item.flag;
      this.$forceUpdate();
    },
    submit() {
      let tags = [];
      this.list.map((r) => {
        if (r.flag) {
          tags.push(r.id);
        }
      });
      tags = tags.join();
      if (this.stIndex < 0 || this.eve == "" || tags == "") {
        this.Toast("请完善评价后提交");
      } else {
        this.api
          .orderEvaluate({
            oid: this.id,
            contents: this.eve,
            tags: tags,
            rating: this.stIndex,
          })
          .then(() => {
            this.Toast.success("评论成功");
            setTimeout(() => {
              this.$router.go(-1);
            }, 1000);
          });
      }
    },
  },
};
</script>
<style scoped>
.title {
  font-size: 0.35rem;
  padding-top: 0.8rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0.2rem;
}
.start-box {
  padding: 0.5rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.start-box img {
  width: 0.4rem;
}
.content-tab {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 1rem;
  margin-top: 0.2rem;
}
.item {
  padding: 0.1rem 0.2rem;
  border: 1px solid #ccc;
  border-radius: 0.1rem;
  margin-right: 0.2rem;
  position: relative;
}
.check-img {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0.3rem;
}
.item.ch {
  border: 1px solid #ed5567;
  color: #ed5567;
}
.textarea {
  margin-top: 0.8rem;
  padding: 0 0.3rem;
  box-sizing: border-box;
}
textarea {
  border-radius: 0.1rem;
  border: 1px solid #ccc;
  background-color: #f8f8f8;
  padding: 0.4rem 0.3rem;
  font-size: 0.32rem;
  width: 100%;
  box-sizing: border-box;
  height: 4rem;
}
.btn {
  margin: 0.3rem;
  margin-top: 0.8rem;
  background: #4fd9d5;
  height: 1rem;
  border-radius: 0.2rem;
  text-align: center;
  line-height: 1rem;
  color: #fff;
  font-weight: bold;
}
</style>
